import { useState } from 'react';
import { NotificationProps as Notification } from '@ch/common/components/notification/types';
import { v4 as uuid } from 'uuid';

export const useQuizNotification = () => {
  const [items, setItems] = useState<Notification[]>([]);

  const removeNotification = (notification: Notification) => {
    setItems(items.filter(item => item.id === notification.id));
  };

  const addNotification = async ({ title, type }: Partial<Notification>) => {
    const newNotification: Notification = {
      title,
      type,
      id: uuid(),
    };
    setItems([...items, newNotification]);

    await new Promise(resolve => setTimeout(resolve, 3000));
    removeNotification(newNotification);
  };

  return {
    items,
    addNotification,
  };
};
